export const EXPIRATION_IN_DAYS = 30;
